<template>
  <main>
    <section class="admin-page">
      <div class="admin-toolbar">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          solo
          flat
          dense
          hide-details
          placeholder="Buscar categoria..."
          background-color="surface_tertiary"
          v-model="filtro_texto"
          class="admin-search"
        />
        <ModalCadastrarCategoriaEnquete />
      </div>
      <div class="admin-table-wrapper">
        <DataTables
          v-if="categorias && categorias.items"
          :data="filteredCategorias"
          :headers="headers"
          :fetchData="fetchData"
          tab="enquetes"
          @categoriaExcluida="handleCategoriaExcluida"
        />
      </div>
    </section>
  </main>
</template>

<script>
import DataTables from "../components/DataTables.vue";
import { mapActions, mapGetters } from "vuex";
import ModalCadastrarCategoriaEnquete from "@/components/Modal/Enquetes/ModalCadastrarCategoriaEnquete.vue";
export default {
  name: "EnquetesCategorias",
  components: { DataTables, ModalCadastrarCategoriaEnquete },
  data() {
    return {
      page: 1,
      // Categorias is a small config table: load the full set (API returns it
      // newest-first) and let the table paginate/search client-side. A tight cap
      // here is what made freshly-created categorias fall off the list.
      size: 1000,
      filtro_texto: "",
      headers: [
        {
          text: "Categoria",
          align: "start",
          sortable: false,
          name: "sigla",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Portal",
          sortable: false,
          name: "description",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Janelas de atualização",
          sortable: false,
          name: "janelas",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Ações",
          sortable: false,
          name: "actions",
          align: "end",
          class: "subtitle-1 font-weight-bold",
          value: "name",
        },
      ],
    };
  },
  beforeCreate() {
    this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.dark;
    this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.light;
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters({
      categorias: "enquetes/getterCategoriasEnquetes",
    }),
    filteredCategorias() {
      if (this.filtro_texto) {
        return this.categorias.items.filter((item) => {
          return (
            (item.dsc_nome_categoria
              .toLowerCase()
              .includes(this.filtro_texto.toLowerCase()) ||
              item.portal_categoria.dsc_nome
                .toLowerCase()
                .includes(this.filtro_texto.toLowerCase()))
          );
        });
      }
      return this.categorias.items;
    },
  },
  methods: {
    ...mapActions({
      getCategorias: "enquetes/getCategoriasEnquetes",
    }),
    async fetchData() {
      await this.getCategorias({ page: this.page, size: this.size });
    },
    async handleCategoriaExcluida() {
      await this.fetchData();
    },
  },
};
</script>

